import { message } from "antd";

import Router from "../..";
import { handleApiError } from "./indexApi";
const BASE_URL = process.env.REACT_APP_API_URL_PRO;

export const userApi = {
  login: async ({ id, appKey, platform = "own", autoLoginEnabled = false }) => {
    try {
      const res = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/user/signin`,
        { id, app_key: appKey, platform }
      );
      if (res.data?.result) {
        localStorage.setItem("authorization", res.data.result.authorization);
        localStorage.setItem("rauthorization", res.data.result.rauthorization);
        localStorage.setItem("autoLoginEnabled", autoLoginEnabled);
      }
      return res.data;
    } catch (err) {
      handleApiError(err, "로그인에 실패했습니다. 잠시 후 다시 시도해주세요.");
      return;
    }
  },

  // 자동 로그인
  autoLogin: async (history) => {
    try {
      const res = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/user/auto/signin`,
        {},
        { headers: { rauthorization: localStorage.getItem("rauthorization") } }
      );

      if (res.data?.result) {
        localStorage.setItem("authorization", res.data.result.authorization);
        localStorage.setItem("rauthorization", res.data.result.rauthorization);
        history.push("/home");
        return; // 성공 시 함수 종료
      }

      // 자동 로그인 실패 시 (에러 메시지가 있거나, result가 없는 경우)
      if (res.data?.error?.text) {
        await message.error(res.data.error.text);
      }
      localStorage.removeItem("authorization");
      localStorage.removeItem("rauthorization");
      localStorage.removeItem("autoLoginEnabled");
    } catch (err) {
      localStorage.removeItem("authorization");
      localStorage.removeItem("rauthorization");
      localStorage.removeItem("autoLoginEnabled");
    }
  },

  signUp: async (payload) => {
    try {
      const res = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/user/signup`,
        payload
      );
      const data = res.data;
      if (data?.error?.text) message.error(data.error.text);
      else if (data?.result) message.info("회원가입이 완료되었습니다");
      return data;
    } catch (err) {
      handleApiError(
        err,
        "회원가입에 실패했습니다. 잠시 후 다시 시도해주세요."
      );
    }
  },

  fetchUserInfo: async () => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/user/get/info`,
        {
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );
      if (res.data?.error?.text) message.error(res.data.error.text);
      return res.data?.result;
    } catch (err) {
      return null;
    }
  },

  checkEmail: async ({ email }) => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/user/check/email`,
        { params: { email } }
      );
      if (res.data?.error?.text) message.error(res.data.error.text);
      return res.data;
    } catch (err) {
      handleApiError(err, "이메일 중복 확인에 실패했습니다.");
    }
  },

  resetPassword: async ({ email }) => {
    try {
      const res = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/user/reset/password/request`,
        { email }
      );
      if (res.data?.error?.text) {
        message.error(res.data.error.text);
        return false;
      }
      if (res.data?.result) {
        message.info("비밀번호 초기화 메일이 발송되었습니다.");
        return true;
      }
      return false;
    } catch (err) {
      handleApiError(
        err,
        "비밀번호 초기화 요청에 실패했습니다. 잠시 후 다시 시도해주세요."
      );
      return false;
    }
  },

  changePassword: async ({ currentPassword, newPassword }) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/user/update/password`,
        { current_password: currentPassword, new_password: newPassword },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data.result) {
        message.success("비밀번호가 성공적으로 변경되었습니다");
        return true;
      }
      if (data.error?.text) {
        if (data.error.text === "비밀번호가 일치하지 않습니다.") {
          message.error("기존 비밀번호가 일치하지 않습니다.");
        } else {
          message.error(data.error.text);
        }
      }
      return false;
    } catch (err) {
      handleApiError(
        err,
        "비밀번호 변경 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요."
      );
      return false;
    }
  },

  issueToken: async () => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/user/issue/token`,
        {
          headers: { rauthorization: localStorage.getItem("rauthorization") },
        }
      );
      if (res.data?.result?.authorization) {
        localStorage.setItem("authorization", res.data.result.authorization);
        return res.data.result.authorization;
      }
      if (res.data?.error?.text) message.error(res.data.error.text);
      return null;
    } catch (err) {
      handleApiError(err, "토큰 재발급에 실패했습니다.");
      return null;
    }
  },

  updateUserInfo: async (userInfo) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/user/update/info`,
        userInfo,
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data.result) {
        message.success("유저 정보가 성공적으로 변경되었습니다.");
        return true;
      }
      if (data.error?.text) message.error(data.error.text);
      return false;
    } catch (err) {
      handleApiError(
        err,
        "유저 정보 업데이트에 실패했습니다. 잠시 후 다시 시도해주세요."
      );
      return false;
    }
  },

  updateAccount: async (payload) => {
    try {
      const res = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/user/update/account`,
        payload,
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (res.data.result) {
        const successMessage =
          payload.user_type === "brand"
            ? "브랜드 정보가 성공적으로 변경되었습니다."
            : payload.user_type === "agency"
              ? "에이전시 정보가 성공적으로 변경되었습니다."
              : "크리에이터 정보가 성공적으로 변경되었습니다.";
        message.success(successMessage);
        return true;
      }
      if (res.data.error?.text) message.error(res.data.error.text);
      return false;
    } catch (err) {
      const errorMessage =
        payload.user_type === "brand"
          ? "브랜드 정보 업데이트에 실패했습니다. 잠시 후 다시 시도해주세요."
          : payload.user_type === "agency"
            ? "에이전시 정보 업데이트에 실패했습니다. 잠시 후 다시 시도해주세요."
            : "크리에이터 정보 업데이트에 실패했습니다. 잠시 후 다시 시도해주세요.";
      handleApiError(err, errorMessage);
      return false;
    }
  },

  unregister: async ({ password, reason }) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/user/unregister`,
        { app_key: password, reason },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data.result) {
        message.success({
          content: "정상적으로 탈퇴되었습니다.",
          duration: 1,
          onClose() {
            localStorage.removeItem("authorization");
            localStorage.removeItem("rauthorization");
            window.location.href = "/signin";
          },
        });
        return true;
      }
      if (data.error?.text) {
        if (data.error.text === "비밀번호가 일치하지 않습니다.") {
          message.error("기존 비밀번호가 일치하지 않습니다.");
        } else {
          message.error(data.error.text);
        }
      }
      return false;
    } catch (err) {
      handleApiError(
        err,
        "회원 탈퇴 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요."
      );
      return false;
    }
  },

  // 비밀번호 재설정
  confirmResetPassword: async ({ token, new_password }) => {
    try {
      const res = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/user/reset/password/confirm`,
        { token, new_password }
      );
      if (res.data.result) {
        message.success("비밀번호가 성공적으로 변경되었습니다.");
        return true;
      }
      if (res.data.error?.text) message.error(res.data.error.text);
      return false;
    } catch (err) {
      handleApiError(err, "비밀번호 재설정에 실패했습니다.");
      return false;
    }
  },

  // 사업자 번호 검증
  validateBusinessNumber: async ({ b_no }) => {
    try {
      const res = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/user/check/business`,
        { b_no }
      );

      if (res.data.result?.status_code !== "OK") {
        message.error("사업자 번호 검증에 실패했습니다.");
        return false;
      }

      const item = res.data.result.data?.[0];

      if (!item) {
        message.error("사업자 번호 검증에 실패했습니다.");
        return false;
      }

      // b_stt_cd가 없으면 유효하지 않은 사업자등록번호
      if (!item.b_stt_cd) {
        message.error("유효하지 않은 사업자 번호입니다.");
        return false;
      }

      // 03은 폐업자
      if (item.b_stt_cd === "03") {
        message.error("폐업 사업자는 사용할 수 없습니다.");
        return false;
      }

      // 01은 정상,02는 휴업자
      if (item.b_stt_cd === "01" || item.b_stt_cd === "02") {
        message.success("사업자 번호 검증이 완료되었습니다.");
        return true;
      }

      message.error("사업자 번호 검증에 실패했습니다.");
      return false;
    } catch (err) {
      handleApiError(err, "사업자 번호 검증에 실패했습니다.");
      return false;
    }
  },
};
